// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7dd7ba40","455":"d119f6b5"}[chunkId] + ".chunk.js";
};